import NavBar from './navbar';
import NavMenu from './navmenu';
import { useAppDispatch, useAppSelector } from '../slices/index';
import * as Forms from '../slices/formsSlice';
import * as Quotes from '../slices/quotesSlice';
import InstructPurchase from './instructpurchase';
import InstructRemortgage from './instructremortgage';
import InstructSale from './instructsale';
import '../App.css';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import icon_instruct from '../assets/Instruct_White.svg';
import { useState } from 'react';
import { instructCase } from '../utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

const Instruct = () => {
	const quotes = useAppSelector(state => state.quotes);
	const dispatch = useAppDispatch();
	const [quoteType, setQuoteType] = useState('');

	const doOnChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
		setQuoteType(e.target.value);
	}

	const doOnClick = () => {
		const setquotetype = () => new Promise((resolve) => resolve(dispatch(Quotes.setQuoteType(quoteType))));
		setquotetype().then(() => {
			dispatch((Forms.createFormWithId("IF")));
		});
	}

	return (
		<div className="Home">
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
				<div className='OrangeBand'>
					<div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 96, height: 96, marginRight: 8 }} src={icon_instruct} alt='Instruct-Icon' />
							<div style={{ marginLeft: 24 }}>
								<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Instruct PLS</div>
							</div>
						</div>
						<div>
							{quotes.quote.type !== '' &&
								<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', padding: 8, fontSize: 18, border: '4px solid white' }} onClick={() => instructCase("IF", "IF")}>
									<div style={{ width: 28, height: 24 }}></div>
									<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Instruct PLS</div>
									<div style={{ width: 28, height: 24 }}>
										{quotes.quote.isInstructing &&
											<FontAwesomeIcon className='fa-spin' style={{ fontSize: 22, marginRight: 8 }} icon={faSync} />
										}
									</div>
								</div>
							}
						</div>
					</div>
				</div>
				{quotes.quote.type === "Purchase" &&
					<InstructPurchase />
				}
				{quotes.quote.type === "Remortgage" &&
					<InstructRemortgage />
				}
				{quotes.quote.type === "Sale" &&
					<InstructSale />
				}
				{quotes.quote.type === "" &&
					<div className='GetQuote'>
						<div style={{ maxWidth: 960, padding: 16, margin: 'auto', color: 'black' }}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<div className='flexGrow2'>
									<select style={{cursor: 'pointer'}} value={quoteType} onChange={(e) => doOnChange(e)}>
										<option value="">Please Select...</option>
										<option value="Purchase">Purchase</option>
										<option value="Remortgage">Remortgage</option>
										<option value="Sale">Sale</option>
									</select>
								</div>
								<div className='flexGrow1'>
									<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', padding: 8, fontSize: 16, border: '4px solid white', borderRadius: 24 }} onClick={() => doOnClick()}>
										<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Instruct PLS</div>
									</div>
								</div>
							</div>
							<div style={{ color: 'black', fontFamily: 'OpenSans-Bold', fontSize: 16, marginTop: 12 }}>Select from the options above to complete the instruction form.</div>
							<div style={{ color: 'black', fontFamily: 'OpenSans-Bold', fontSize: 16 }}>Once you have submitted, your clients will then recieve their own portal account information within 2 hours - allowing them to get started as quickly as possible and one step closer to getting those all important keys!</div>
						</div>
					</div>
				}
			</div>

			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default Instruct;